import React from 'react';
import { ProductId } from 'services/products/types';
import { connect } from 'react-redux';
import { makeSelectProductTypeFieldValue } from 'services/products/selectors';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';

interface OwnProps {
    productId: ProductId;
}

interface ConnectedProps {
    type?: string;
}

type Props = OwnProps & ConnectedProps;

export class ProductsTableRowTypeFieldValueComponent extends React.PureComponent<
    Props
> {
    render(): string | null {
        const { type } = this.props;

        if (!type) return null;

        return type;
    }
}

const mapStateToProps = createStructuredSelector<AppState, ConnectedProps>({
    type: makeSelectProductTypeFieldValue()
});

export default connect(mapStateToProps)(
    ProductsTableRowTypeFieldValueComponent
);
